/**
 * @prettier
 */

import React from "react";
import { useTranslation } from "react-i18next";

// Components
import CustomButton from "../../../components/CustomButton";
import Header from "../../../components/Header";
import SubmissionFlowStepper from "../../../components/SubmissionFlowStepper";

export default function NativeCameraFallbackState({
    initiateNativeCapture,
    isOverLayError,
    primaryFocusRef,
}) {
    const { t } = useTranslation();

    return (
        <div className="root-layout-container id-pal-overlay">
            <div className="">
                {isOverLayError === true && (
                    <>
                        <Header />
                        <SubmissionFlowStepper />
                        <h1
                            className="id-pal-overlay-fallback-title"
                            ref={primaryFocusRef}
                            tabIndex={0}
                        >
                            {t("idpal_camera_failed_to_open")}
                        </h1>
                        <CustomButton
                            id={"open_native_camera"}
                            className={"btn hidden"}
                            label={t("idpal_open_camera")}
                            handleClick={() => initiateNativeCapture()}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
